<template>
  <v-row>
    <v-col>
      <v-toolbar dense>
        <v-btn
          v-for="(tri, index) in [1, 2, 3, 4]"
          :key="index"
          class="mr-2"
          :loading="getLoadingStatus"
          :disabled="getLoadingStatus"
          color="primary"
          @click="getExpensesRange(tri)"
        >{{ tri }}º Quarter of {{ year }}</v-btn>
      </v-toolbar>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  data: () => ({
    year: new Date().toISOString().substr(0, 4)
  }),
  computed: {
    ...mapGetters(["getLoadingStatus"])
  },
  methods: {
    ...mapActions(["getExpensesRange"])
  }
};
</script>

<style></style>
